<template>
  <div class="Authentication">
    <h2>二次身份验证</h2>
    <div class="live_regester_input">
      <p class="p2">
        <a-input placeholder="图片验证码" v-model:value="verify"/>
        <span class="p2_right">
          <img :src="urlcodeimg" alt="loading">
          <span @click="f5s">
            <i>看不清？</i>
          </span>
        </span>
      </p>
      <p class="p3">
        <input type="text" v-model="verificationcode" name="code" placeholder="请输入验证码" @input="verificationcode=verificationcode.replace(/[^\d]/g,'')">
        <button @click="sendInformation" :disabled="isCountDown" :class="{mask:isCountDown}">{{isCountDown?Count:"发送验证码"}}</button>
      </p>
      <div @click="validate">
        <a-button type="primary" style="width:100%">
          确认
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import {notification} from 'ant-design-vue';
export default {
  name: "Authentication",
  props:{
    urlcodeimg: String, // 验证码图片地址
  },
  data() {
    return {
      Count: "(60s)",
      number: 60, // 短信验证倒计时
      verificationcode: "", //手机验证码
      isCountDown: false, // 触发倒计时
      verify: '', // 图片验证码
    }
  },
  mounted() {
  },
  methods: {
    f5s(){
      this.$emit("f5s")
    },
    sendInformation(){
      if (this.verify == "") {
        notification.open({
          message: '警告！',
          description: "图片验证码不能为空",
          duration: 2,
          key: "23",
          top: '20px',
        });
        return
      }
      this.countdown();
      this.$emit("sendInformation")
    },
    //60秒倒计时
    countdown() {
      this.isCountDown = true
      let num = this.number
      let ids = setInterval(() => {
        num -= 1
        this.Count = `(${num}s)`
        if (num <= 0) {
          this.isCountDown = false
          clearInterval(ids)
        }
      }, 1000);
    },
    validate(){
      this.$emit("validate",this.verify,this.verificationcode)
    },
  }
}
</script>
<style scoped lang="less">
.Authentication {
  width: 500px;
  height: 400px;
  background: #FFFFFF;
  border-radius: 4px;
  margin: 0 auto;
  position: relative;
  top: 50%;
  margin-top: -200px;
  box-sizing: border-box;
  padding: 0 70px;
  overflow: hidden;
  h2{
    font-size: 30px;
    color: #4C4C4C;
    line-height: 30px;
    font-weight: bold;
    text-align: center;
    margin: 50px 0 75px;
  }
  .live_regester_input {
    .p2{
      border: none;
      display: flex;
      justify-content: space-between;
      input{
        width: 150px;
        border: 1px solid #7B7B7B;
      }
      .p2_right{
        border: 1px solid #7B7B7B;
        display: inline-block;
        width: 170px;
        height: 32px;
        border-radius: 4px;
        margin: 0;
        img{
          width: 80px;
          height: 30px;
          margin-left: 5px;
        }
        span{
          cursor: pointer;
          user-select: none;
          margin: 0;
          margin-left: 12px;
          i{
            font-size: 12px;
            font-style: italic;
            margin: 0;
          }
        }
      }
    }
    .p3{
      border: none;
      display: flex;
      justify-content: space-between;
      input{
        border: 1px solid #7B7B7B;
        border-radius: 2px;
        height: 36px;
        width: 200px;
        padding-left: 40px;
      }
      button{
        width: 150px;
        height: 36px;
        background: #D6E6FF;
        color: #1877F2;
        outline: none;
        border: none;
        border: 1px solid #1877F2;
        cursor: pointer;
      }
    }
    .span1{
      width: 255px;
      height: 16px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      margin-left: 50px;
      margin-top: 100px;
      text-align: center;
      display: block;
      color: #1877F2;
    }
    p {
      margin-bottom: 20px;
      width: 356px;
      height: 34px;
      border-radius: 2px;
      border: 1px solid #7b7b7b;
      display: flex;
      align-items: center;
      border-radius: 2px;
      span {
        color: #525252;
        font-size: 14px;
        margin-left: 12px;
        margin-right: 12px;
      }
      input {
        border: none;
      }
      .mask {
        background: rgba(0, 0, 0, 0.4) !important;
        border: none !important;
      }
    }
  }
}
</style>
